module.exports = __webpack_public_path__ + "static/media/Rose.53ce1964.jpg";